// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__3QOgc","actionsCol":"EnrolledClinics_actionsCol__1MnKm"};